import { SimpleChanges, Component, OnInit, Input, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Table } from 'primeng/table';
import { IColumnDefinition } from '../../common/models/column-definition';
import { ColumnFormatterService } from '../../common/services/column-formatter.service';
import { MyActivityWidgetItem } from '../models/my-activity-widget-item';
import { ITableColumn } from '../../common/models/table';
import * as _lodash from 'lodash';


@Component({
  selector: 'mojo-activity-table',
  templateUrl: './activity-table.component.html'
})
export class ActivityTableComponent implements OnInit, AfterViewInit {
  @ViewChild('dt') dataTable: Table;


  @Input()
  selectedColumns: Array<IColumnDefinition> = [];

  @Input()
  activities: Array<MyActivityWidgetItem> = [];

  @Input()
  tableTitle: string;

  table: any;

  constructor(
    private readonly columnFormatterService: ColumnFormatterService,
    private readonly changeDetector: ChangeDetectorRef
  ) { }


  export(): void {
    this.dataTable.exportCSV();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    
  }


  private getCssClassNameFromStatusDescription(statusDescription: string = ''): Array<string> {
    let result = statusDescription.replace(/[!"#$%&'()\*\+,\./:;<=>\?@\[\\\]‌​;^`{\|}~ ]+/g, '')
      .toLowerCase();
    if (result.startsWith("approval")) {
      result = result.replace(' ', '');
    }
    return ['color_indicator', result];
  }

  buildTable() {

    if (!this.selectedColumns || !this.activities) {
      return;
    }
    const fieldNames = this.selectedColumns.map(colDef => colDef.Field);
    const rows = this.activities.map(activity => _lodash.pick(activity, fieldNames));

    const tableColumns = this.selectedColumns.map(colDef => {
      return {
        Name: colDef.Field,
        Header: colDef.Header,
        Sortable: colDef.Sortable,
        Type: colDef.FormatType,
        IsSystemColumn: colDef.IsSystemColumn,
        TypeName: null,
        Ordinal: null,
        Width: colDef.Width
      } as ITableColumn;
    }
    );


    this.table = {
      Columns: tableColumns,
      Rows: rows
    };
    this.changeDetector.markForCheck();

    console.log('activity-table', fieldNames, this.activities, this.table);


  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['activities'] || changes['selectedColumns']) {
      this.buildTable();
    }
  }

  getColSize(width: number): string {
    return width + 'px';
  }

  formatByColumnType(rowData, columnDefinition: ITableColumn): string {
    return this.columnFormatterService.formatByColumnType(rowData, columnDefinition);
  }

  onRowSelect(event) {
    var formRef = event.data.FormRef;
    var url = '/Activity/EditActivity?formId=' + formRef;
    window.location.href = url;
  }
}
